import { z } from 'zod';

export const EventInputSchema = z.object({
  tool_id: z.string().uuid(),
  session_id: z.string().uuid(),
  event_type: z.enum(['view', 'start', 'progress', 'complete', 'cta_click', 'lead_capture']),
  page_url: z.string().url().optional(),
  referrer: z.string().optional(),
  metadata: z.record(z.unknown()).default({}),
});
export type EventInput = z.infer<typeof EventInputSchema>;
